import {additionalDataForAddToBasket} from '@aboutyou/legacy-tracking-sdk';

export const getAdditionalBasketData = () => {
  return process.browser && window.clientState
    ? additionalDataForAddToBasket(window.clientState)
    : undefined;
};
